const isNumber = (value: string) => {
	return /^\d+$/.test(value);
};

export default isNumber;
